module.exports = __webpack_public_path__ + "static/media/liftup-default-2.55371ca2.jpg";